import { call, put, takeEvery } from "redux-saga/effects";
import { sportsRequest } from "../../api/sports";
import { sportsActions } from "../../store/sports/actions";
import { SPORTS_REQUEST } from "../../constants/sports";

function* sportsRequestSaga(): any {
  try {
    const sports = yield call(sportsRequest);

    yield put(sportsActions.sportsSuccessAction(sports));
  } catch (e: any) {
    yield put(sportsActions.sportsFailureAction(e));
  }
}
function* sportsSaga() {
  yield takeEvery(SPORTS_REQUEST, sportsRequestSaga);
}

export default sportsSaga;
